export default __webpack_public_path__ + "static/media/electric2.2c7ce059.jpeg";